import React from 'react';
import {
    TextInput,
    DateInput,
    Edit,
    required,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    SimpleForm,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ErrorBoundary from '../ErrorBoundary';

const styles = {
    root: { alignItems: 'flex-start' },
};


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const PackingEditActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath}  label='Ready To Ship List'/>
    </CardActions>
);


const ShippingToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);

const ReadyToShipEdit = props => (
<ErrorBoundary>
<Edit title='Update Shipping Case Number' {...props}  actions={<PackingEditActions/>} >
    <SimpleForm  toolbar={<ShippingToolbar />}> 
        <Table  style={{ margin: 'auto',  fontSize:'12px',  width:"100%" }} >
            <TableBody >                 
                <TableRow >
                    <TableCell align="left">Shipping Case Number<br/><TextInput source="shipping_case_no" label="" validate={required()}/></TableCell>
                    <TableCell align="left">Shipping Date<br/><DateInput source="shipping_date" label="" locales="en-us" /></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Case Number<br/><TextInput source="case_no" label="" validate={required()} disabled /></TableCell>
                    <TableCell>Unit Control Number<br/><TextInput source="ucn" label="" validate={required()} disabled /></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Name<br/><TextInput source="name" label=""  disabled /></TableCell>
                    <TableCell>Bleed Date<br/><DateInput source="bleed_date" label="" disabled locales="en-us"/></TableCell>
                </TableRow>
            </TableBody>
        </Table>    
    </SimpleForm>

</Edit>
</ErrorBoundary>
);
export default  withStyles(styles)(ReadyToShipEdit) ;
